import { checkOrgDeleted, isLkDisabledError } from '@/utils/orgCheck'

export default async function ({ store, redirect, route }) {
  // Проверяем авторизацию через токены
  const hasTokens =
    localStorage.getItem('accessToken') && localStorage.getItem('refreshToken')
  if (!hasTokens) {
    // Только если мы еще не на странице авторизации
    if (route.path !== '/auth') {
      return redirect('/auth')
    }
    return
  }

  // Получаем данные пользователя из store или localStorage
  let user = store?.state?.auth?.user

  // Если данные еще не загружены в store, берем их из localStorage
  if (!user) {
    const userFromStorage = localStorage?.getItem('user')
    if (userFromStorage) {
      try {
        user = JSON.parse(userFromStorage)
      } catch (e) {
        // Если не удалось распарсить, редиректим на авторизацию
        if (route?.path !== '/auth') {
          return redirect('/auth')
        }
        return
      }
    } else {
      // Если нет данных пользователя, редиректим на авторизацию
      if (route?.path !== '/auth') {
        return redirect('/auth')
      }
      return
    }
  }

  // Если пользователь не админ и уже прошел onboarding, редиректим в организацию
  if (Array.isArray(user?.roles) && !user.roles.includes('admin')) {
    if (user?.employees?.length >= 1) {
      let employee = user.employees[0]
      const orgId = employee?.orgId

      // Загружаем недостающие данные через Vuex Store
      if (!employee.departments || !employee.org) {
        try {
          await store.dispatch('onboarding/fetchOnboardingData', orgId)
          // Обновляем ссылку на employee после загрузки данных
          employee = store.state.auth.user.employees[0]
        } catch (error) {
          if (isLkDisabledError(error)) {
            const targetPath = `/org/${orgId}/calendar`
            if (route?.path !== targetPath) {
              return redirect(targetPath)
            }
            return
          }

          checkOrgDeleted(error, { store, redirect })
          return
        }
      }

      // Проверяем статус онбординга через геттер
      const isOnboardingCompleted =
        store.getters['onboarding/isOnboardingCompleted']

      if (isOnboardingCompleted) {
        // Онбординг полностью завершен, редиректим в ЛК
        const targetPath = `/org/${orgId}/calendar`
        if (route?.path !== targetPath) {
          return redirect(targetPath)
        }
      }
    }
  }
}
